import ProviderRequestIdView from './BankingEventsView';

export default ProviderRequestIdView;
